import * as React from 'react';
import { cn } from '@/lib/utils';
import { RadioGroup } from '@/components/ui/radio-group';
import { FormRadio } from '../form';

const FilterRadioGroup = React.forwardRef(({ className, value, onValueChange, radios = [], ...props }, ref) => (
  <RadioGroup
    ref={ref}
    className={cn('c-filter-radio-group', 'mb-3', className)}
    value={value}
    onValueChange={onValueChange}
    {...props}
  >
    {radios?.map(radio => (
      <FormRadio
        key={radio.id}
        id={radio.id}
        value={radio.value}
        label={radio.label}
      />
    ))}
  </RadioGroup>
));
FilterRadioGroup.displayName = 'FilterRadioGroup';

export { FilterRadioGroup };
